import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import NextHead from "next/head";
import React from "react";
import { FullStorySnippet } from "./fullstory";
export function Head(param) {
    var title = param.title, description = param.description, noIndex = param.noIndex, children = param.children;
    return /*#__PURE__*/ _jsxs(NextHead, {
        children: [
            /*#__PURE__*/ _jsx("meta", {
                charSet: "UTF-8"
            }),
            /*#__PURE__*/ _jsx("title", {
                children: title !== null && title !== void 0 ? title : ""
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "description",
                content: description !== null && description !== void 0 ? description : ""
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "icon",
                sizes: "180x180",
                href: "/static/apple-touch-icon.png"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "apple-touch-icon",
                href: "/static/apple-touch-icon.png"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "mask-icon",
                href: "/static/favicon-mask.svg",
                color: "#5bbad5"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "icon",
                href: "/static/favicon.ico"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/static/favicon-32x32.png"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/static/favicon-16x16.png"
            }),
            /*#__PURE__*/ _jsx(FullStorySnippet, {}),
            noIndex && /*#__PURE__*/ _jsx("meta", {
                name: "robots",
                content: "noindex"
            }),
            children
        ]
    });
}
